// @global navigator

// TODO: Separate to generic lib

export function setGeolocationState({ state, setState, props }) {
  return setState({
    geolocation: { ...state.geolocation, ...props }
  })
}

export function geolocationSupported({ state, actions }) {

  const supported = 'geolocation' in navigator

  if (supported!==state.supported) {
    actions.setGeolocationState({ supported })
  }
  return supported
}

export function refreshGeolocation({ state, actions }) {

  if (!actions.geolocationSupported()
    || (state.geolocation.longitude && state.geolocation.latitude)
  ) return

  navigator.geolocation.getCurrentPosition(function(position) {

    const { coords: { longitude, latitude } } = position

    //console.log('getCurrentPosition', { longitude, latitude })

    actions.setGeolocationState({ longitude, latitude, requestSuccess: true })

  }, e => {
    console.warn(e.message)
    actions.setGeolocationState({ requestFail: true })
  })

}

// Unused

export function subscribeGeolocation({ actions }) {

  if (!actions.geolocationSupported()) return

  console.log('subscribeGeolocation')

  const watchId = navigator.geolocation.watchPosition(function(position) {
    const { coords: { longitude, latitude } } = position
    console.log('watchPosition', position)
    actions.setGeolocationState({ longitude, latitude })
  }, e => console.log('watchPosition: error', e))

  return watchId
}

export function unsubscribeGeolocation({ watchId, actions }) {
  if (!actions.geolocationSupported()) return

  console.log('unsubscribeGeolocation')

  navigator.geolocation.clearWatch(watchId)
}
